module.exports = __webpack_public_path__ + "assets/media/makaed_n.f2a3f9dc.jpg";